import { render, staticRenderFns } from "./glovo_portal.vue?vue&type=template&id=45e5a78d&scoped=true&"
import script from "./glovo_portal.vue?vue&type=script&lang=js&"
export * from "./glovo_portal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e5a78d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e5a78d')) {
      api.createRecord('45e5a78d', component.options)
    } else {
      api.reload('45e5a78d', component.options)
    }
    module.hot.accept("./glovo_portal.vue?vue&type=template&id=45e5a78d&scoped=true&", function () {
      api.rerender('45e5a78d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/glovo/location/tabs/glovo_portal.vue"
export default component.exports